module.exports = __webpack_public_path__ + "static/media/Download_on_the_App_Store_Badge.2928664f.svg";